import React from "react";

type Props = React.ImgHTMLAttributes<HTMLImageElement> & {
  fallbackSrc?: string;
};

const DEFAULT_FALLBACK = "/favicon.ico";

export default function SafeImage({ fallbackSrc, onError, ...props }: Props) {
  const handleError: React.ReactEventHandler<HTMLImageElement> = (e) => {
    const img = e.currentTarget;
    img.onerror = null; // prevent infinite loop if fallback fails too
    img.src = fallbackSrc || DEFAULT_FALLBACK;
    onError?.(e);
  };

  return <img {...props} onError={handleError} />;
}

